import React, { forwardRef } from 'react';
import parse from 'html-react-parser';
import { useIntl } from 'react-intl';
import {
  PrintPreviewHeader,
  PrintPreviewFooter,
} from '@mummssoftware/common-ui/PagedJS';
import {
  getCreatedByString,
  getPhysicianString,
  getPsoRoles,
  getRoles,
  getRolesString,
} from '@mummssoftware/utils/utils';
import { PrintDiv, StandingOrdersInfoDiv } from '../../components';
import defaults from '../../translations/en.json';

type fwdRef = React.MutableRefObject<any> | React.Ref<any>;

type SingularPsoUIProps = {
  pso: any;
  patientOrdersGlobal: mumms.Order[] | null;
  patient?: mumms.patient;
};

export const SingularPsoUI = forwardRef(
  ({ pso, patient, patientOrdersGlobal }: SingularPsoUIProps, ref: fwdRef) => {
    const { formatMessage } = useIntl();

    const checkedPrns: any = getPsoRoles(pso);
    const roles = getRoles(checkedPrns);
    const textRoles = roles.length ? roles.toString() : false;

    const globalOrderSameId = patientOrdersGlobal?.find(
      (globalPSO: any) =>
        globalPSO.patientstandingorderid &&
        globalPSO.patientstandingorderid.toString() === pso.id,
    );

    return (
      <PrintDiv ref={ref}>
        <PrintPreviewHeader patient={patient} />
        {pso.templatebasedtext ? (
          <>
            <StandingOrdersInfoDiv id="pso-expanded-panel" key={pso.id}>
              <p>{getCreatedByString(pso)}</p>
              {globalOrderSameId && (
                <p>{getPhysicianString(globalOrderSameId)}</p>
              )}
              {textRoles && <p>{getRolesString(roles, textRoles)}</p>}
              {parse(pso.templatebasedtext)}
            </StandingOrdersInfoDiv>
          </>
        ) : (
          <div>{formatMessage(defaults.noText)}</div>
        )}
        <PrintPreviewFooter />
      </PrintDiv>
    );
  },
);
